export namespace ICorpRequest {

  export enum Action {
    CorpsMake = 'Corps_Mk',
  }

  export enum Command {
    Add = 'add',
    Get = 'get',
    Update = 'upd',
    ChangeRef = 'refChange',
    ChangeCorp = 'changeCorp',
  }

  export interface IPayloadGetCorp {
    corpId: number;
  }

  export interface IPayloadChangeRefCode {
    corpId: number;
  }

  export interface IPayloadChangeCorp {
    refCode: string;
  }

  export interface IPayloadCreateCorp {
    name: string;
    phone: string;
    email: string;
  }
}
